// extracted by mini-css-extract-plugin
export var container = "_95-0";
export var error = "_95-9";
export var label = "_95-5";
export var light = "_95-6";
export var md = "_95-3";
export var sm = "_95-2";
export var thin = "_95-8";
export var thinBold = "_95-7";
export var vertical = "_95-4";
export var xs = "_95-1";